export default __webpack_public_path__ + "static/media/ilustrasi-3.c1763d46.svg";